/* de blinkie - customer photo strip behaviour (31 Aug 2026)

   ARROW SPEED is 950ms on an ease-in-out curve. The previous expo-out curve
   spent nearly all its speed in the first moment and then crawled, which
   reads as a lunge however long the animation lasts - that, not the
   duration, was what felt fast. The arrows advance one card
   per press at every size, and the duration scales with the distance moved. Autoplay never runs at or below 767px: the
   per-frame marquee writes fractional scroll positions every frame, which
   reads as jitter on a phone and fights a finger mid-swipe.

   THE STUTTER on click was CSS `scroll-snap-type` fighting the animation:
   glide() used to switch snap off only during each animation and back on
   right as it finished - Chrome re-evaluates snap alignment against a
   moving scrollLeft even when set programmatically, so every click ended
   with a small correction jump. Fixed by turning snap off once, for good,
   the moment this script takes over.

   Cards are cloned once so the loop never shows a seam. Clones are hidden
   from screen readers and taken out of the tab order.
*/
(function(){
  var MOBILE = window.matchMedia('(max-width: 767px)');
  var STEP_CARDS_MOBILE  = 1;
  var STEP_CARDS_DESKTOP = 1;
  var GLIDE_MS   = 1400;

  function cubicBezier(x1, y1, x2, y2){
    function a(p1, p2){ return 1 - 3 * p2 + 3 * p1; }
    function b(p1, p2){ return 3 * p2 - 6 * p1; }
    function c(p1){ return 3 * p1; }
    function bezier(t, p1, p2){ return ((a(p1, p2) * t + b(p1, p2)) * t + c(p1)) * t; }
    function slope(t, p1, p2){ return 3 * a(p1, p2) * t * t + 2 * b(p1, p2) * t + c(p1); }
    return function (x){
      if (x <= 0) return 0;
      if (x >= 1) return 1;
      var t = x;
      for (var i = 0; i < 8; i++){
        var d = slope(t, x1, x2);
        if (Math.abs(d) < 1e-6) break;
        t -= (bezier(t, x1, x2) - x) / d;
      }
      return bezier(t, y1, y2);
    };
  }
  var EASE = cubicBezier(0.4, 0, 0.2, 1);

  function init(root){
    var track = root.querySelector('[data-ugc-track]');
    if (!track || track.dataset.ugcReady) return;
    track.dataset.ugcReady = '1';

    var count = root.querySelector('[data-ugc-count]');
    var btns  = root.querySelectorAll('[data-ugc-dir]');
    var auto  = root.getAttribute('data-ugc-autoplay') === 'true';
    var speed = parseFloat(root.getAttribute('data-ugc-speed')) || 14;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var real  = track.children.length;
    if (!real) return;

    var down = false, sx = 0, sl = 0, moved = 0;
    var running = auto && !reduce && !MOBILE.matches;
    var paused = false;
    var pos = 0;
    var raf = null;
    var vel = 0;
    var RAMP = 4;

    track.style.scrollSnapType = 'none';

    if (running){
      for (var c = 0; c < real; c++){
        var clone = track.children[c].cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        var link = clone.querySelector('a');
        if (link) link.tabIndex = -1;
        track.appendChild(clone);
      }
    }

    function step(){
      var first = track.children[0];
      if (!first) return 280;
      var st = getComputedStyle(track);
      var g = parseFloat(st.columnGap || st.gap) || 0;
      return first.getBoundingClientRect().width + g;
    }
    function maxScroll(){ return track.scrollWidth - track.clientWidth; }
    function loopWidth(){ return step() * real; }

    function update(){
      if (count && !running){
        var idx = Math.round(track.scrollLeft / step()) + 1;
        count.textContent = Math.min(Math.max(idx, 1), real) + ' / ' + real;
      }
      for (var i = 0; i < btns.length; i++){
        var d = parseInt(btns[i].getAttribute('data-ugc-dir'), 10);
        btns[i].disabled = running ? false
          : (d < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= maxScroll() - 2);
      }
    }

    function stopForGood(){
      if (!running) return;
      running = false;
      if (count) count.hidden = false;
      update();
    }

    function glide(to, ms){
      if (raf) cancelAnimationFrame(raf);
      vel = 0;
      if (!running) to = Math.max(0, Math.min(to, maxScroll()));
      if (reduce){ track.scrollLeft = to; pos = to; update(); return; }
      var dur = ms || GLIDE_MS;
      var from = track.scrollLeft, dist = to - from, t0 = null;
      raf = requestAnimationFrame(function frame(t){
        if (t0 === null) t0 = t;
        var p = Math.min(1, (t - t0) / dur);
        track.scrollLeft = from + dist * EASE(p);
        pos = track.scrollLeft;
        if (p < 1){ raf = requestAnimationFrame(frame); }
        else { raf = null; update(); }
      });
    }

    if (running){
      if (count) count.hidden = true;
      var last = null;
      requestAnimationFrame(function tick(t){
        if (last === null) last = t;
        var dt = (t - last) / 1000; last = t;
        var target = (running && !paused && !down) ? speed : 0;
        vel += (target - vel) * Math.min(1, dt * RAMP);
        if (!down && !raf && (target > 0 || Math.abs(vel) > 0.05)){
          pos += vel * dt;
          var w = loopWidth();
          if (w > 0 && pos >= w) pos -= w;
          track.scrollLeft = pos;
        }
        requestAnimationFrame(tick);
      });

      root.addEventListener('pointerenter', function(){ paused = true; });
      root.addEventListener('pointerleave', function(){ paused = false; });
      root.addEventListener('focusin', function(){ paused = true; });
    }

    for (var b = 0; b < btns.length; b++){
      (function(btn){
        btn.addEventListener('click', function(){
          stopForGood();
          var d = parseInt(btn.getAttribute('data-ugc-dir'), 10);
          var cards = MOBILE.matches ? STEP_CARDS_MOBILE : STEP_CARDS_DESKTOP;
          glide(track.scrollLeft + d * step() * cards, GLIDE_MS * cards);
        });
      })(btns[b]);
    }

    track.addEventListener('scroll', function(){ if (!running) update(); }, { passive: true });
    track.addEventListener('keydown', function(e){
      if (e.key === 'ArrowRight'){ e.preventDefault(); stopForGood(); glide(track.scrollLeft + step()); }
      if (e.key === 'ArrowLeft'){ e.preventDefault(); stopForGood(); glide(track.scrollLeft - step()); }
    });

    track.addEventListener('pointerdown', function(e){
      if (e.pointerType === 'touch') return;
      down = true; moved = 0; sx = e.clientX; sl = track.scrollLeft;
      track.classList.add('is-dragging');
    });
    track.addEventListener('pointermove', function(e){
      if (!down) return;
      var dx = e.clientX - sx;
      if (Math.abs(dx) > moved) moved = Math.abs(dx);
      track.scrollLeft = sl - dx;
      pos = track.scrollLeft;
    });
    function endDrag(){
      if (down && moved > 6) stopForGood();
      down = false;
      track.classList.remove('is-dragging');
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('pointerleave', endDrag);
    track.addEventListener('touchstart', function(){ stopForGood(); }, { passive: true });
    track.addEventListener('click', function(e){
      if (moved > 6){ e.preventDefault(); e.stopPropagation(); }
      moved = 0;
    }, true);

    window.addEventListener('resize', update);
    update();
  }

  function boot(){
    var roots = document.querySelectorAll('[data-ugc-root]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
